import { getImageFullUrl, isFullUrl } from "../app/Common/Enum/helper";

const Direction = {
    UP: "up",
    DOWN: "down",
    LEFT: "left",
    RIGHT: "right",
}
const getCircleX = (radians, radius) => {
    return Math.cos(radians) * radius;
}

const getCircleY = (radians, radius) => {
    return Math.sin(radians) * radius;
}

const getAngle = (point, ref, isConvertToDegree = false) => {
    let yDis = Math.abs(point.y - ref.y)
    let xDis = Math.abs(point.x - ref.x)

    // Move ref to (0,0) for easier reference
    point = {...point}
    ref = {...ref}
    point.x -= ref.x
    point.y -= ref.y

    // y-axis are inverted
    point.y *= -1

    ref.x -= ref.x
    ref.y -= ref.y

    let quadrant = 1
    let radAdjust = (angle) => angle
    let degreeAdjust = (angle) => angle
    if (point.x >= 0 && point.y >= 0) {
        quadrant = 1
        degreeAdjust = (angle) => 90 - angle
        radAdjust = (angle) => (Math.PI / 2) - angle
    }
    else if (point.x >= 0 && point.y < 0) {
        quadrant = 2
        degreeAdjust = (angle) => 90 + angle
        radAdjust = (angle) => Math.PI/2 + angle
    }
    else if (point.x < 0 && point.y < 0) {
        quadrant = 3
        degreeAdjust = (angle) => 270 - angle
        radAdjust = (angle) => Math.PI * 3 / 2 - angle
    }
    else if (point.x < 0 && point.y >= 0) {
        quadrant = 4
        degreeAdjust = (angle) => 270 + angle
        radAdjust = (angle) => Math.PI * 3 / 2 + angle
    }

    let baseRadAngle = Math.atan2(yDis, xDis)
    let finalRadAngle = radAdjust(baseRadAngle)

    return {
        angle: isConvertToDegree ? radiansToDegrees(finalDegreeAngle) : finalRadAngle,
        quadrant,
    }
}

function radiansToDegrees(radians) {
  var pi = Math.PI;
  return radians * (180/pi);
}

const STROKE_DEFAULT = "#808184";
function SeatLayout(canvasId, tableWidth) {

    var isTouchDevice = 'ontouchstart' in document.documentElement;
    this.tableWidth = tableWidth || 100;
    this.canvas = document.getElementById(canvasId);
    this.context = this.canvas.getContext("2d");

    var base_image = new Image();
    let isBackgroundImageLoaded = false

    base_image.src = null;
    base_image.onload = () => {
        isBackgroundImageLoaded = true;
        this.render()
    }

    var elemLeft = () => {
        return this.canvas.offsetLeft
    };
    var elemTop = () => {
        return this.canvas.offsetTop
    };

    // this.selectedSeats_id = [];
    // this.selectedSeats_object = [];
    // this.selectedSeats_objectSorted = [];
    this.children = [];
    this.addElement = function () {

    };

    this.setBackgroundImage = (imgUrl) => {
        isBackgroundImageLoaded = false

        if (imgUrl && !isFullUrl(imgUrl)) {
            imgUrl = getImageFullUrl(imgUrl)
        }
        base_image.src = imgUrl

        // If image set to null, image.onload will not be triggered,
        // so we need to manual trigger the redraw
        if (imgUrl == null) {
            this.render()
        }
    }

    this.removeItem = (item) => {
        for (var i = 0; i < this.children.length; i++) {
            if (this.children[i] === item) {
                this.children.splice(i, 1);
                break;
            }
        }
        this.render();
    }

    this.removeAll = () => {
        this.children = []
        this.render()
    }

    this.setSize = ({width,height}) => {
        this.width = width
        this.height = height
    }

    var me = this;

    var domSelectedSeat = document.getElementById("selected-seat");

    let mouseDownCoor = null
    let mouseDownOnLayoutItem = null

    let getCoordinate = (e) => {
        let coor = null
        let touch = {}
        let canvas = this.canvas
        let canvasRect = canvas.getBoundingClientRect()
        if (isTouchDevice) {
            // alert("isTouchDevice")
            // Position of canvas relative to viewport
            if (e.touches && e.touches[0]) {
                touch = {
                    x: e.touches[0].pageX,
                    y: e.touches[0].pageY,
                }
                coor = {
                    x: e.touches[0].pageX - elemLeft(),
                    y: e.touches[0].pageY - elemTop(),
                    // x: e.touches[0].pageX - elemLeft(),
                    // y: e.touches[0].pageY - elemTop()
                };
            } else if (e.changedTouches && e.changedTouches.length > 0) {
                touch = {
                    x: e.changedTouches[0].pageX,
                    y: e.changedTouches[0].pageY,
                }
                coor = {
                    x: e.changedTouches[0].pageX - elemLeft(),
                    y: e.changedTouches[0].pageY - elemTop()
                };
            }
        } else {
            touch = {
                x: e.offsetX,
                y: e.offsetY,
            }
            coor = {
                x: e.offsetX,
                y: e.offsetY,
                // x: e.pageX - elemLeft(),
                // y: e.pageY - elemTop()
            };
        }
        let data = {
            coor: coor,
            canvas: canvasRect,
            touch: touch,
        }
        return coor
    }

    // Set to true is got mouse drag event, so that
    // on mouseup, mouse clicked event handler can skip
    let skipMouseClick = false
    this.onMouseDown = (e) => {
        e.preventDefault();
        var downCoor = getCoordinate(e)
        mouseDownCoor = downCoor

        for (var i = this.children.length - 1; i > -1; i--) {
            let clickedItem = this.children[i].getClickedItem(downCoor);
            if (clickedItem) {
                this.mouseDownOnLayoutItem = clickedItem;

                if (isEditMode) {
                    // Set move mouse listener to handle the drag action
                    $(this.canvas).mousemove(this.onMouseDrag);
                    $(this.canvas).on('touchmove', this.onMouseDrag)
                }
                break;
            }
        }
    };

    this.onMouseUp = (e) => {
        $(this.canvas).off('mousemove', this.onMouseDrag);
        $(this.canvas).off('touchmove', this.onMouseDrag);

        if (this.mouseDownOnLayoutItem && this.tempTable) {
            const tempTable = this.tempTable
            mouseDownOnLayoutItem.offsetCenter({
                x: tempTable.center.x - mouseDownOnLayoutItem.center.x,
                y: tempTable.center.y - mouseDownOnLayoutItem.center.y
            })
            mouseDownOnLayoutItem.isHidden = false
            mouseDownOnLayoutItem.finalize()
            this.removeItem(tempTable)
            isDragging = false
            this.tempTable = null
            this.mouseDownOnLayoutItem = null
            this.skipMouseClick = true
            this.render()
        } else if (this.mouseDownOnLayoutItem && !this.tempTable) {
            // Touch start on Table, but not enough dragging to trigger
            // move table, assume is a 'click' on table
            this.onClick(e)
        }
    };

    let isEditMode = false
    let tempTable = null
    let isDragging = false
    this.onMouseDrag = (e) => {
        var coor = getCoordinate(e)
        if (Math.abs(mouseDownCoor.x - coor.x) > 10 || Math.abs(mouseDownCoor.y - coor.y) > 10) {
            isDragging = true

            const offsetCoor = {
                x: coor.x - mouseDownCoor.x,
                y: coor.y - mouseDownCoor.y
            };

            if (this.mouseDownOnLayoutItem) {
                mouseDownOnLayoutItem = this.mouseDownOnLayoutItem

                if (!this.tempTable) {
                    var tempTable = Object.assign(
                        Object.create(
                          Object.getPrototypeOf(mouseDownOnLayoutItem)
                        ),
                        mouseDownOnLayoutItem
                      );

                    // Once we done copy the object being dragged,
                    // hide the original object
                    mouseDownOnLayoutItem.isHidden = true

                    // The dragged object is not selected
                    tempTable.isSelected = false
                    tempTable.isGhostImage = true

                    tempTable.id = "T1";
                    tempTable.sortPriority = 100;

                    let newCenter = {
                        x: mouseDownOnLayoutItem.center.x + offsetCoor.x,
                        y: mouseDownOnLayoutItem.center.y + offsetCoor.y,
                    };

                    tempTable.type = mouseDownOnLayoutItem.type;
                    tempTable.center = newCenter;
                    tempTable.radius = mouseDownOnLayoutItem.radius * 0.8;
                    tempTable.showCenter = true;
                    tempTable.name = mouseDownOnLayoutItem.name;
                    tempTable.addToLayout(this);
                    this.tempTable = tempTable
                } else {
                    let tempTable = this.tempTable
                    tempTable.offsetCenter(offsetCoor)
                }
            }
            this.render();
        }
    }

    document.getElementById(canvasId).addEventListener("click", this.onClick, false);
    // document.getElementById(canvasId).addEventListener("touchend", this.onClick, false);

    this.onClick = (event) => {
        if (me.skipMouseClick) {
            // Most probably mouse drag event happened, so we skip
            // ONE TIME mouse click event
            me.skipMouseClick = false
            return
        }
        var clickCoor = getCoordinate(event) //  {x:event.pageX - elemLeft(), y:event.pageY - elemTop()};

        var clickedItem;
        for (var i = 0; i < me.children.length; i++) {
            clickedItem = me.children[i].getClickedItem(clickCoor);
            if (clickedItem) {
                if (clickedItem.onSelected) {
                    clickedItem.onSelected()
                }
                break;
            }
        }
        me.render();
    }

    /**
     * Clear all drawings on canvas
     */
    this.clear = () => {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    this.drawGridLines = () => {
        const width = this.canvas.offsetWidth
        const height = this.canvas.offsetHeight

        let x = 0
        let y = 0
        const ctx = this.context
        ctx.strokeStyle = "#d7d9dd77";

        // Draw vertical gridline
        while (x < width) {
            x += 30
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();
        }
        // Draw horizontal gridline
        while (y < height) {
            y += 30
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }
    }
    this.render = function () {
        this.clear()
        if (isBackgroundImageLoaded) {
            this.context.drawImage(base_image, 0, 0, this.width, this.height);
        }
        else {
            this.context.fillStyle = "#fff8eb";
            this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
        if (isDragging) {
            this.drawGridLines()
        }
        this.children.forEach(function (child) {
            child._render();
        });
    };

    this.canvas.onmousedown = this.onMouseDown
    this.canvas.ontouchstart = this.onMouseDown

    this.canvas.onmouseup = this.onMouseUp
    this.canvas.ontouchend = this.onMouseUp

    this.setEditMode = (_isEditMode) => {
        isEditMode = _isEditMode
    }
}

function LayoutItem() {
    this.id = null;
    this.children = [];
    this.sortPriority = 0;
    this.center = {
        x: 50,
        y: 150
    };
    this.radius = 50;
    this.context = null
    this.isHidden = false
    this.showBorder = true
}
LayoutItem.prototype = {
    createGradient: function(color, options = {}) {
        // Create gradient
        let ctx = this.context
        const center = options.center || this.center
        // const {center} = this
        const radius = options.radius || this.radius
        var grd = ctx.createRadialGradient(center.x, center.y, radius * 0.2, center.x, center.y, radius);
        grd.addColorStop(0, color || "red");
        grd.addColorStop(1, "white");
        return grd;
    },
    addToLayout: function (layout) {
        this.layout = layout

        if (this instanceof SubTicket) {
            this.addSubticket(layout)
        }
        else {
            this.addChildren(layout)
            // // Add this as children to the parent layout
            // if (!layout.children) {
            //     layout.children = [];
            // }
            // layout.children.push(this);
            // var context = layout.context;

            // // Store the parent layout and context to be
            // // passed to children later
            // this.context = context;
        }
    },
    addChildren: function(layout) {
        this.layout = layout
        // Add this as children to the parent layout
        if (!layout.children) {
            layout.children = [];
        }
        layout.children.push(this);
        var context = layout.context;

        // Store the parent layout and context to be
        // passed to children later
        this.context = context;
    },
    addSubticket: function(layout) {
        this.layout = layout || this.layout
        // Add this as children to the parent layout
        if (!layout.subTickets) {
            layout.subTickets = [];
        }
        layout.subTickets.push(this);
        var context = layout.context;

        // Store the parent layout and context to be
        // passed to children later
        this.context = context;
    },
    defaultRender: function () {
        if (this.render) {
            this.render()
            return
        }
        else if (this.type == 'roundrect') {
            let width = this.width || 50
            let height = this.height || 100
            let c = this.context
            this.context.beginPath();
            c.fillStyle = "green";
            c.strokeStyle = "blue";
            c.lineWidth = 5;

            const cornerRadius = {
                upperLeft: 0,
                upperRight: 0,
                lowerLeft: 0,
                lowerRight: 0
            }
            // {
            //     upperLeft: 10,
            //     upperRight: 10
            // },
            c.roundRect(this.center.x - width / 2, this.center.y - height / 2, width, height, cornerRadius, true, true);

            this.context.beginPath();
            c.lineWidth = 2;
            return
        }
        var context = this.context;
        context.moveTo(this.center.x, this.center.y);
        context.beginPath();
        context.strokeStyle = "#808184";
        context.arc(this.center.x, this.center.y, this.radius, 0, 2 * Math.PI);
        if (this.color && !this.isGhostImage) {
            context.fillStyle = this.createGradient(this.color);
            context.fill();
            if (this.showBorder) {
                context.stroke();
            }
        } else {
            if (this.showBorder) {
                context.stroke();
            }
        }

        this._renderTickets({width: this.radius, height: this.radius})
    },
    _postRender: function() {
        if (this.postRender) {
            this.postRender()
            return
        }
        if (this.showCenter) {
            // Table name will block the table center dot
            return
        }
        if (this.isHidden) {
            return
        }
        let ctx = this.context
        ctx.font = "12px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "blue";
        ctx.fillText(this.name || "Table", this.center.x, this.center.y);
    },
    _renderCenter: function() {
        if (this.renderCenter) {
            this.renderCenter()
            return
        }
        var context = this.context;
        context.beginPath();
        context.fillStyle = "#333333";
        context.arc(this.center.x, this.center.y, 2, 0, 2 * Math.PI);
        context.fill();
    },
    _drawSubticket: function(center, radius, color) {
        const context = this.context
        context.moveTo(center.x, center.y);
        context.beginPath();
        context.strokeStyle = "#808184";
        context.arc(center.x, center.y, radius, 0, 2 * Math.PI);

        context.fillStyle = color
        context.fill();
        context.stroke();
    },

    // Render tickets as simple box at right side
    _renderTickets: function({width, height,}) {

        // Assume box is our main shape, then O1, O2, O3, will
        // be the position of each ticket
        // |-----| O1
        // |     | O2
        // |_____| O3

        let gapBetweenTicket = 5

        // 0 rad will start at right side of circle. We want to start at top
        //      1.5pi
        // 1pi __|__ 0 / 2pi
        //       |
        //      0.5pi

        const maxNumberOfSubticketPerShape = 10
        let radianOffset = 1.5 * Math.PI
        let radianPerSubticket = 2 * Math.PI * (1 / maxNumberOfSubticketPerShape);
        
        (this.subTickets || []).forEach(t => {
            let ticketWidth = 10
            let ticketHeight = 10
            const radius = ticketWidth / 2
            let center = {}

            if (!this.type) {
                center = {
                    x: this.center.x + getCircleX(radianOffset, this.radius + 3),
                    y: this.center.y + getCircleY(radianOffset, this.radius + 3),
                }
                radianOffset += radianPerSubticket
            }
            this._drawSubticket(center, radius, t.color)
        })
    },
    _render: function () {
        if (this.isHidden) {
            return
        }

        var context = this.context;
        if (this.preRender) {

            this.preRender.call(this)
        }

        if (this.customRender) {
            this.customRender()
        } else {
            this.defaultRender()
        }

        if (this.showCenter) {
            this._renderCenter()
        }

        // If this object has other custom rendering
        // such as table name, other decorations, etc
        this._postRender()

        for (var i = 0; i < this.children.length; i++) {
            this.children[i].render();
        }
    },
    getRoundRectClickedItem: function (coordinate) {
        let xBounds = {
            min: this.center.x - this.width / 2,
            max: this.center.x + this.width / 2,
        }
        let yBounds = {
            min: this.center.y - this.height / 2,
            max: this.center.y + this.height / 2,
        }
        if (coordinate.x >= xBounds.min &&
            coordinate.x <= xBounds.max &&
            coordinate.y >= yBounds.min &&
            coordinate.y <= yBounds.max) {
            return this
        }
        return null
    },
    offsetCenter: function (offset) {
        if (!this._center) {
            // Store the original center so that we can
            // A. apply final offset more easily
            // B. undo the state to original state

            // 1. Original - {x:0, y:0}
            // 2. User drag x + 10 (reference to the mouseDown coordinate)
            // 3. Current - {x: 10, y: 0}
            // 4. User drag a bit further, x + 12 (2 more px than at (2) )
            // 5. i.  If we do another offset of 12px from x=10, then we are wrong
            //    ii. In fact, we should do a offset of 12px from the original center
            this._center = {
                ...this.center
            }
        }

        this.center.x = this._center.x + offset.x
        this.center.y = this._center.y + offset.y

        this.overflowCheck()
        for (let i = 0; i < this.children.length; i++) {
            this.children[i].offsetCenter(offset)
        }
    },
    overflowCheck: function() {
        const width = this.layout.canvas.offsetWidth
        const height = this.layout.canvas.offsetHeight
        // Overflow check to make sure center of object
        // do not exit canvas
        if (this.center.x > width) {
            this.center.x = width
        }
        else if (this.center.x < 0) {
            this.center.x = 0
        }
        if (this.center.y > height) {
            this.center.y = height
        }
        else if (this.center.y < 0) {
            this.center.y = 0
        }
    },
    finalize: function () {
        // Done draging the table, save the final state
        // Future drag offset will be calculated from this
        // final state
        this._center = null
        for (let i = 0; i < this.children.length; i++) {
            this.children[i].finalize()
        }

        // Callback after drag move, most probably
        // is API to save latest position to DB
        if (this.onFinalize) {
            this.onFinalize()
        }
    },
    reset: function () {
        // Done draging the table, save the final state
        this.center = {
            ...this._center
        }
        this._center = null
        for (let i = 0; i < this.children.count; i++) {
            this.children[i].reset()
        }
    }
};

function straightLineDistance(coor1, coor2) {
    var dist_x = coor2.x - coor1.x;
    var dist_y = coor2.y - coor1.y;
    var dist_x2 = dist_x * dist_x;
    var dist_y2 = dist_y * dist_y;
    return Math.sqrt(dist_x2 + dist_y2);
}

export function RectTable() {
    LayoutItem.call(this);

    this.tickets = []
    this.addTicket = (tableSession) => {
        this.tickets.push(tableSession)
    }

    this.preRender = () => {
        if (this.isHidden) {
            return
        }
        if (this.isSelected) {
            let ctx = this.context
            this.radius
            const margin = 0.4
            const radiusMultiplier = 1 + margin

            // Selection box
            ctx.beginPath()
            ctx.fillStyle = "#FFFF0088";

            const {width,height} = this
            const [w1,h1] = [width+20, height+20]
            const x = (this.center.x - width / 2) - 10
            const y = (this.center.y - height / 2) - 10
            ctx.fillRect(x, y, w1, h1)

            // Border
            // ctx.beginPath()
            // ctx.strokeStyle = "#808184";
            // ctx.rect(x, y, w1, h1)
            // ctx.stroke()
        }
    }
    this.createGradient = function(color) {
        // Create gradient
        let ctx = this.context
        const {center} = this

        const end = this.width > this.height ? this.width : this.height
        var grd = ctx.createRadialGradient(center.x, center.y, 5, center.x, center.y, end + 20);
        grd.addColorStop(0, color || "red");
        grd.addColorStop(1, "white");
        return grd;
    }
    this.getClickedItem = function (coordinate) {
        let xBounds = {
            min: this.center.x - this.width / 2,
            max: this.center.x + this.width / 2,
        }
        let yBounds = {
            min: this.center.y - this.height / 2,
            max: this.center.y + this.height / 2,
        }
        if (coordinate.x >= xBounds.min &&
            coordinate.x <= xBounds.max &&
            coordinate.y >= yBounds.min &&
            coordinate.y <= yBounds.max) {
            return this
        }
        return null
    }
    this.renderCenter = function() {
        var context = this.context;
        context.beginPath();
        context.fillStyle = "#FF0000";
        context.arc(this.center.x, this.center.y, 2, 0, 2 * Math.PI);
        context.fill();
    }

    this.render = function() {
        let width = this.width || 50
        let height = this.height || 100
        let c = this.context
        this.context.beginPath();

        c.strokeStyle = STROKE_DEFAULT;
        c.fillStyle = "transparent"
        if (this.color && !this.isGhostImage) {
            c.fillStyle = this.createGradient(this.color);
        }

        c.lineWidth = 2;

        const defaultCornerRadius = {
            upperLeft: 0,
            upperRight: 0,
            lowerLeft: 0,
            lowerRight: 0
        };

        c.roundRect(this.center.x - width / 2, this.center.y - height / 2, width, height, this.cornerRadius || defaultCornerRadius, true, this.showBorder);

        this._renderTickets({width, height})

        this.context.beginPath();
        c.lineWidth = 2;
        return
    }

    this._getSubticketCoor = function(index) {

    }

    // Render tickets as simple box at right side
    this._renderTickets = function({width, height,}) {
        const radius = 5

        // This is a rectangle instead of circle, so we might not have uniform distance
        // from center of shape to the edge, and the distance varies based on the angle.
        // For optimal UI appearance, we will place the SubTicket evenly spaced around
        // the total length of the edges instead of evenly spaced by angle. (Diagram A)
        // Spacing by angle will cramp SubTicket tighter when distance from center is small
        // and further apart when distance is big (Diagram B)
        // 
        // Diagram A (Ignoring corner radius)
        // =========
        //   (N-1)   N     1    2     3
        //       |--------------------|
        //  (N-2)|                    | 4
        //       |                    |
        //       |                    | 5
        //       |                    |
        //       |                    |
        //       |--------------------|
        //
        // 
        // Diagram B
        // =========
        //   (N-1)     N  1 2 3 4     5
        //       |--------------------|
        //  (N-2)|                    | 6
        //       |--------------------|

        const maxNumberOfSubticketPerShape = 10 // N
        let radianOffset = 1.5 * Math.PI
        let radianPerSubticket = 2 * Math.PI * (1 / maxNumberOfSubticketPerShape);

        // We shall start at top center of shape, then move in clockwise manner,
        // taking 90 turn once we reach the corner of the shape.
        //        Start move
        //         to right        Change move to down once
        //  |-------->|--------->| we reach top-right corner
        // /|\                   |
        //  |                    |
        //  |                    |
        //  |                    |
        //  |                    |
        //  |                   \|/
        //  |<-------------------|
        //                          Move to left once we reach
        //                          bottom-right corner
        // 
        // To simplify things, we can divide movement into 5 distinct part,
        // each with their own quota of length/direction to move. Movement of cursor
        // along the direction in each part shall consume quota. Once quota
        // had been completely consume, we move in next part, carrying forward the
        // remaining movement length that yet to be completed
        //
        // Assume cursor coordinate format = cursor{x, y}, and we have 100 x 100 rectangle
        // 1. We at start,  cursor{50, 0},      initial state   = [50, +x], [100, -y], [100, -x], [100, -y], [100, +x]
        // 2. Move 50 unit, cursor{50 + 30, 0}, next state      =  [(50 - 30), +x], [100, -y], [100, -x], [100, -y], [100, +x]
        //                  cursor{80, 0},      next state      =  [20, +x], [100, -y], [100, -x], [100, -y], [100, +x]
        // 3. Move 30 unit, we have to break into 2 minor step, first step to finish off the quota of 1st part, 2nd step we use quota/direction
        //    of next part
        //    i.   Move 20 unit,    cursor{80 + 20, 0},     next state =  [(20 - 20), +x], [100, -y], [100, -x], [100, -y], [100, +x]
        //                          cursor{100, 0},         next state =  [0, +x], [100, -y], [100, -x], [100, -y], [100, +x]
        //    ii.  Move 10 unit,    cursor{100, 0 - 10},    next state =  [0, +x], [(100 - 10), -y], [100, -x], [100, -y], [100, +x]
        // 4. Repeat step 1 - 3 until all required movement are completed (or stop when we ran of of quota)
        let totalPerimeter = (this.width + this.height) * 2
        let moveLengthPerSubticket = totalPerimeter / maxNumberOfSubticketPerShape

        // Start at top center
        let cursor = {
            x: this.center.x,
            y: this.center.y - (this.height / 2)
        };

        let movementParts = [
            {
                quota: this.width / 2,
                direction: Direction.RIGHT,
            },
            {
                quota: this.height,
                direction: Direction.DOWN,
            },
            {
                quota: this.width,
                direction: Direction.LEFT,
            },
            {
                quota: this.height,
                direction: Direction.UP,
            },
            {
                quota: this.width / 2,
                direction: Direction.RIGHT,
            },
        ]

        const processMovement = function(cursor, moveCursorFunc, lengthToMove, currentMovement, otherMovementParts) {
            // Have enough quota, do it in one step
            if (currentMovement.quota >= lengthToMove) {
                moveCursorFunc(cursor, currentMovement.direction, lengthToMove)
                currentMovement.quota -= lengthToMove
                return currentMovement
            }
            else {
                // Don't have enough quota, run recursively until complete movement
                // 1. Use up remaining quota to move cursor
                moveCursorFunc(cursor, currentMovement.direction, currentMovement.quota)
                lengthToMove -= currentMovement.quota

                // 2. Proceed to use next movement part
                currentMovement = otherMovementParts.shift()
                if (currentMovement) {
                    return processMovement(cursor, moveCursorFunc, lengthToMove, currentMovement, movementParts)
                }
            }
        }
        
        const moveCursorFunc = this._moveCursor.bind(this)
        let currentMovement = movementParts.shift();

        const cornerRadiusMapping = {
            1: this.cornerRadius.upperRight,
            2: this.cornerRadius.lowerRight,
            3: this.cornerRadius.lowerLeft,
            4: this.cornerRadius.upperLeft,
        }
        const quadrantOffsetMapping = {
            1: {
                x: -1,
                y: 1,
            },
            2: {
                x: -1,
                y: -1,
            },
            3: {
                x: 1,
                y: -1,
            },
            4: {
                x: 1,
                y: 1,
            },
        }

        let subTickets = this.subTickets || []
        
        subTickets.forEach((t, index) => {

            // Handle corner radius
            // 1. Check cursor in which quadrant
            //        Q4 |  Q1
            //         __|__ 
            //        Q3 |  Q2

            // Y-axis are inverted compared to normal trigo
            let { quadrant } = getAngle(cursor, this.center)

            let subTicketCenter = {...cursor}
            let cornerRadius = cornerRadiusMapping[quadrant]
            if (cornerRadius) {

                let relativeXoffset = Math.abs((subTicketCenter.x - this.center.x) / (this.width / 2))
                let relativeYoffset = Math.abs((subTicketCenter.y - this.center.y) / (this.height / 2))

                // Bigger aspect ratio, pull more
                let aspectRatio = this.width > this.height ? this.height / (this.width || this.height) : this.width / (this.height || this.width)

                // 0.5 obtained by trial and error until we get the best looking UI
                let trialAndErrorConstant = 0.5
                let yOffset = aspectRatio * trialAndErrorConstant * (cornerRadius * this.height / 4) * relativeXoffset * quadrantOffsetMapping[quadrant].y // Further x distance, pull more y
                let xOffset = aspectRatio * trialAndErrorConstant * (cornerRadius * this.width / 4) * relativeYoffset * quadrantOffsetMapping[quadrant].x// Further y distance, pull more x
                subTicketCenter = {
                    x: subTicketCenter.x + xOffset,
                    y: subTicketCenter.y + yOffset,
                }
            }

            // First subticket draw without moving cursor
            this._drawSubticket(subTicketCenter, radius, t.color)

            // Move cursor to next position to prepare to draw next ticket
            if (currentMovement) {
                currentMovement = processMovement(cursor, moveCursorFunc, moveLengthPerSubticket, currentMovement, movementParts)
            }
        })
    }

    this._moveCursor = function(cursor, direction, length) {
        //         -y
        //          ^
        //        / | \
        // -x <-----|----> +x
        //          |
        //         \|/ 
        //          v
        //         +y
        switch (direction) {
            case Direction.UP:
                cursor.y -= length
                break
            case Direction.DOWN:
                cursor.y += length
                break
            case Direction.RIGHT:
                cursor.x += length
                break
            case Direction.LEFT:
                cursor.x -= length
                break
        }
    }
}
RectTable.prototype = Object.create(LayoutItem.prototype);

export function SubTicket() {
    LayoutItem.call(this);
}
SubTicket.prototype = Object.create(LayoutItem.prototype);
SubTicket.prototype.addToLayout = function (layout) {
    LayoutItem.prototype.addToLayout.call(this, layout);
    // this.addSeats(this);
};

export function RoundTable() {
    LayoutItem.call(this);

    this.tickets = []
    this.addTicket = (tableSession) => {
        this.tickets.push(tableSession)
    }

    this.preRender = () => {
        if (this.isHidden) {
            return
        }
        if (this.isSelected) {
            let ctx = this.context
            this.radius
            const margin = 0.4
            const radiusMultiplier = 1 + margin

            // Selection box
            ctx.beginPath()
            ctx.fillStyle = "#FFFF0088";

            // Round table
            const x = this.center.x - this.radius * radiusMultiplier
            const y = this.center.y - this.radius * radiusMultiplier
            const width = this.radius * radiusMultiplier * 2
            ctx.fillRect(x, y, width, width)

            // Border
            // ctx.beginPath()
            // ctx.strokeStyle = "#808184";
            // ctx.rect(x, y, width, width)
            // ctx.stroke()
        }
    }

    this.postRender = () => {
        if (this.showCenter) {
            // Table name will block the table center dot
            return
        }
        if (this.isHidden) {
            return
        }
        let ctx = this.context
        ctx.font = "12px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "blue";
        ctx.fillText(this.name || "Table", this.center.x, this.center.y);
    }

    this.getClickedItem = function (coordinate) {
        var distanceFromCenter = straightLineDistance(coordinate, this.center);
        if (distanceFromCenter < this.radius) {
            return this;
        }
        if (this.children) {
            for (var i = this.children.length - 1; i > -1; i--) {
                // Reverse step to ensure top item got selected instead of lower
                // hidden item
                var clickedItem = this.children[i].getClickedItem(coordinate);
                if (clickedItem) {
                    return clickedItem;
                }
            }
        }
        return null;
    }
}
RoundTable.prototype = Object.create(LayoutItem.prototype);
RoundTable.prototype.addToLayout = function (layout) {
    LayoutItem.prototype.addToLayout.call(this, layout);
    // this.addSeats(this);
};

function RoundTableSeat() {
    LayoutItem.call(this);
}
RoundTableSeat.prototype = Object.create(LayoutItem.prototype);

function createGradient(ctx, center, color) {
    // Create gradient
    var grd = ctx.createRadialGradient(center.x, center.y, 5, center.x, center.y, 100);
    grd.addColorStop(0, color || "red");
    grd.addColorStop(1, "white");
    return grd;
}

/**
 * Draws a rounded rectangle using the current state of the canvas.
 * If you omit the last three params, it will draw a rectangle
 * outline with a 5 pixel border radius
 * @param {Number} x The top left x coordinate
 * @param {Number} y The top left y coordinate
 * @param {Number} width The width of the rectangle
 * @param {Number} height The height of the rectangle
 * @param {Object} radius All corner radii. Defaults to 0,0,0,0;
 * @param {Boolean} fill Whether to fill the rectangle. Defaults to false.
 * @param {Boolean} stroke Whether to stroke the rectangle. Defaults to true.
 */
CanvasRenderingContext2D.prototype.roundRect = function (x, y, width, height, radius, fill, stroke) {
    var cornerRadius = {
        upperLeft: 0,
        upperRight: 0,
        lowerLeft: 0,
        lowerRight: 0
    };
    if (typeof stroke == "undefined") {
        stroke = true;
    }
    if (typeof radius === "object") {
        for (var side in radius) {
            cornerRadius[side] = radius[side] / 2;
        }
    }

    this.beginPath();
    this.moveTo(x + (cornerRadius.upperLeft * width), y);
    this.lineTo(x + width - (cornerRadius.upperRight * width), y);
    this.quadraticCurveTo(x + width, y, x + width, y + (cornerRadius.upperRight * height));
    this.lineTo(x + width, y + height - (cornerRadius.lowerRight * height));
    this.quadraticCurveTo(x + width, y + height, x + width - (cornerRadius.lowerRight * width), y + height);
    this.lineTo(x + (cornerRadius.lowerLeft * width), y + height);
    this.quadraticCurveTo(x, y + height, x, y + height - (cornerRadius.lowerLeft * height));
    this.lineTo(x, y + (cornerRadius.upperLeft * height));
    this.quadraticCurveTo(x, y, x + (cornerRadius.upperLeft * width) , y);
    this.closePath();

    if (stroke) {
        this.stroke();
    }
    if (fill) {
        this.fill();
    }
}
export default SeatLayout;